import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';
import { SnackbarStatus, useSnackbar } from '@weareopenr/component-library';
import { getMenuLabels, IMenuLabel } from 'src/api/getMenuLabels';
import { getBrandId } from 'src/helpers/getBrandId/getBrandId';
import { QueryKeys } from '../QueryKeys';

export const useMenuLabels = (options?: UseQueryOptions<IMenuLabel[]>): UseQueryResult<IMenuLabel[]> => {
  const { showSnackbar } = useSnackbar();

  return useQuery<IMenuLabel[]>({
    queryKey: [QueryKeys.menuLabels, getBrandId()],
    queryFn: getMenuLabels,
    onError: () =>
      showSnackbar({ status: SnackbarStatus.ERROR, message: 'Something went wrong whilst fetching menu labels' }),
    ...options,
  });
};
